<template>
  <div>
    <img
      class="d-none d-sm-none d-md-none d-lg-none d-xl-inline-block"
      src="../assets/My-GDQ-Management.svg"
      width="400"
    >
    <img
      class="d-none d-sm-inline-block d-md-inline-block d-lg-inline-block d-xl-none"
      src="../assets/My-GDQ-Management.svg"
      width="340"
    >
    <img
      class="d-inline-block d-sm-none d-md-none d-lg-none"
      src="../assets/GDQ-White.svg"
      width="100"
    >
    &nbsp;
    <b-badge
      v-if="gdqmodetext!=''"
      class="d-none d-sm-inline"
    >
      {{ gdqmodetext }}
    </b-badge>
  </div>
</template>
<script>
import { config } from '../../config'
export default {
  data () {
    return {
      gdqmodetext: (config.mode == 'live') ? '' : config.mode == 'stage' ? 'TEST' : 'DEV'
    }
  }
}
</script>
<style>
</style>
